@import '~style-sheet-helpers/core.less';

.title {
  font-weight: @normal;
}

.container {
  display: flex;
  font-size: 14px;
}

.chart-section {
  width: 50%;
}

.helper-message {
  line-height: 22px;
  max-width: 420px;
}
